import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "confirmation-summary-container",
  class: "govuk-panel govuk-panel--confirmation",
  "aria-labelledby": "confirmation-summary-title",
  role: "alert",
  tabindex: "-1"
}
const _hoisted_2 = {
  class: "govuk-panel__title",
  id: "confirmation-summary-title"
}
const _hoisted_3 = { class: "govuk-panel__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.confirmationExists)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.confirmationData.title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.confirmationData.body), 1)
      ]))
    : _createCommentVNode("", true)
}